import { render, staticRenderFns } from "./integral-history.vue?vue&type=template&id=ba9c15c8&scoped=true"
import script from "./integral-history.vue?vue&type=script&lang=js"
export * from "./integral-history.vue?vue&type=script&lang=js"
import style0 from "./integral-history.vue?vue&type=style&index=0&id=ba9c15c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9c15c8",
  null
  
)

export default component.exports